import { CasinoLayoutEnum } from "@finbackoffice/fe-core";
import dynamic from "next/dynamic";
import { ReactNode } from "react";

const SlotsCompactLayout = dynamic(() => import("./compact/SlotsCompactLayout"), { ssr: true });

export const getSlotsLayout = (page: ReactNode, layout: CasinoLayoutEnum) => {
    switch (layout) {
        default:
            return <SlotsCompactLayout>{page}</SlotsCompactLayout>;
    }
};
